import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-regenerate-answer-confirmation',
  template: `<div class="flex justify-between content-center">
      <h3 mat-dialog-title>Regenerate answer</h3>
      <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content class="flex flex-col gap-2">
      <p>Regenerating this answer will overwrite any existing response.</p>

      <p>Please confirm that you’d like to proceed.</p>

      <form [formGroup]="regenerateAnswersForm">
        <mat-checkbox formControlName="regenerateAnswers">
          <i
            [class.error]="
              regenerateAnswersControl.invalid &&
              regenerateAnswersControl.touched
            "
          >
            I understand and wish to proceed.
          </i>
        </mat-checkbox>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions class="flex gap-2">
      <button
        type="button"
        mat-stroked-button
        mat-dialog-close
        color="primary"
        class="flex-1 primaryColor-border"
      >
        Cancel
      </button>
      <button
        class="flex-1"
        type="submit"
        mat-flat-button
        color="primary"
        (click)="confirmRegeneration()"
      >
        Confirm
      </button>
    </mat-dialog-actions>`,
  styles: `
    .error {
      color: red;
    }
    h3 {
      margin-bottom: 0;
    }
  `,
  standalone: false,
})
export class RegenerateAnswerConfirmationComponent {
  regenerateAnswersForm = new FormGroup({
    regenerateAnswers: new FormControl(false, [Validators.requiredTrue]),
  });

  get regenerateAnswersControl() {
    return this.regenerateAnswersForm.controls.regenerateAnswers;
  }

  constructor(
    private dialogRef: MatDialogRef<RegenerateAnswerConfirmationComponent>
  ) {}

  confirmRegeneration() {
    if (this.regenerateAnswersForm.invalid) {
      this.regenerateAnswersForm.markAllAsTouched();
      return;
    }

    this.dialogRef.close(true);
  }
}
